module.exports = __webpack_public_path__ + "static/media/instalogo.d5a0c6c4.png";